/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getAll() {
    return axios.get(`${this.apiVersion}/accounts`);
  }

  updateCustomMessages(data) {
    return axios.put(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/update_appointment_reminder_hours`,
      data
    );
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  getMedxUsuariosAgenda() {
    return axios.get(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/medx_usuarios_agenda`
    );
  }

  ninsaudeConnect(data) {
    return axios.post(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/ninsaude_connect`,
      data
    );
  }

  ninsaudeDisconnect() {
    return axios.delete(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/ninsaude_disconnect`
    );
  }

  getNinsaudeProfissionais() {
    return axios.get(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/ninsaude_profissionais`
    );
  }

  getNinsaudeUnidades() {
    return axios.get(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/ninsaude_unidades`
    );
  }

  deleteMemedLogo() {
    return axios.delete(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/memed_logo`
    );
  }
}

export default new AccountAPI();
